const FormSectionHeader = ({ heading, children }) => {
  return (
    <div style={{ marginBottom: 20 }}>
      <div
        style={{
          padding: "8px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
        }}
      >
        <h1 style={{fontSize: '1rem'}}>{heading}</h1>
      </div>
      {children}
    </div>
  );
};

export default FormSectionHeader;
